import { useEffect,useState } from 'react';

// Hook
function useWindowSize() {
    // * = isDevice
    const isClient = typeof window === 'object';

    function getSize() {
        return {
            width: isClient ? window.innerWidth : undefined,
        };
    }

    const [windowSize, setWindowSize] = useState(getSize);
    // const screenWidth = useWindowSize().width;
    const [inputSize,setInputSize]=useState('medium');
    const [device,setDevice]=useState('');

    useEffect(()=>{
        if(windowSize.width>=768 && windowSize.width<=1024 ){
            setInputSize('small');
            setDevice('tablet');
        }
        else if(windowSize.width<768){
            setInputSize('small');
            setDevice('mobile');
        }
        else{
            setInputSize('medium');
            setDevice('desktop');
        }
    },[windowSize]);

    useEffect(() => {
        if (!isClient) {
            return false;
        }

        function handleResize() {
            setWindowSize(getSize());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []); // Empty array ensures that effect is only run on mount and unmount

    return {screenWidth: windowSize.width, inputSize,device};
}

export default useWindowSize;